import { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
    setIsEmptyInput,
    setMessageLimit,
} from "../../../features/messagesSlice";
import {
    CHARACTER_LIMIT,
    SOURCE_CHAT,
    INPUT_PLACEHOLDER_MSG,
} from "../../../../constants";

TextInput.propTypes = {
    sendNewMessage: PropTypes.func.isRequired,
    textBoxContainer: PropTypes.shape({
        current: PropTypes.instanceOf(Element),
    }),
};

export default function TextInput({ sendNewMessage, textBoxContainer }) {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.session.token);
    const isEmptyInput = useSelector((state) => state.messages.isEmptyInput);
    const messageLimit = useSelector((state) => state.messages.messageLimit);
    const loadingReply = useSelector((state) => state.messages.loadingReply);
    const isEnd = useSelector((state) => state.messages.isEnd);

    // Focus textbox when needed.
    useEffect(() => {
        if (token || !isEnd || !loadingReply) {
            textBoxContainer.current.focus();
        }
    }, [token, isEnd, loadingReply]);

    const handlePaste = (event) => {
        event.preventDefault();
        const bufferText = (
            (event.originalEvent || event).clipboardData || window.Clipboard
        ).getData("Text");
        document.execCommand("insertText", false, bufferText);
    };

    const handleInputCharacter = () => {
        const containerElement = textBoxContainer.current;
        let userInput = containerElement.innerHTML
            .replace(/<div>|<br.*?>/gi, "\n")
            .replace(/<\/div>/g, "")
            .replace(/&nbsp;/g, " ")
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&apos;/g, "'")
            .replace(/\n/g, "")
            .trim();

        if (userInput === "") {
            dispatch(setIsEmptyInput(true));
        } else {
            dispatch(setIsEmptyInput(false));
        }

        // Check character limit
        if (userInput.length > CHARACTER_LIMIT) {
            dispatch(setMessageLimit(true));
            userInput = userInput.substring(0, CHARACTER_LIMIT);
            containerElement.innerHTML = userInput;
            const range = document.createRange();
            const sel = window.getSelection();
            range.setStart(containerElement.childNodes[0], userInput.length);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        } else {
            dispatch(setMessageLimit(false));
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter" && !event.shiftKey && !isEmptyInput) {
            event.preventDefault();
            sendNewMessage(textBoxContainer);
        }
    };

    return (
        <div
            ref={textBoxContainer}
            className={`text-box ${messageLimit ? "message-limit" : ""}`}
            // contentEditable={true}
            contentEditable={loadingReply === false}
            disabled={false}
            onPaste={handlePaste}
            onInput={handleInputCharacter}
            onKeyDown={handleKeyDown}
            data-text={INPUT_PLACEHOLDER_MSG}
        ></div>
    );
}
